import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import { CurrencyService } from 'app/services/models/currency.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-currency-create',
  templateUrl: './currency-create.component.html',
  encapsulation:ViewEncapsulation.None
})
export class CurrencyCreateComponent implements OnInit {
  currencyForm: FormGroup;
  constructor(private formBuilder: FormBuilder,private _coreSidebarService:CoreSidebarService,private toastrService:ToastrService,private currencyService:CurrencyService) { }

  ngOnInit(): void {
    this.currencyForm = this.formBuilder.group({
      currencyName: ['', [Validators.required, Validators.maxLength(25)]]
    });
  }

  get currencyName() {
    return this.currencyForm.get('currencyName');
  }

  async onSubmit() {
    if (this.currencyForm.valid) {
      const result = await this.currencyService.createCurrency(this.currencyForm.value.currencyName)
      if(result.status == true){
        this.currencyService.sendEvent(true);
        this.toastrService.success(result.message)
      }
       
      else
        this.toastrService.error(result.message);

    } else {
      this.toastrService.error("Formu doğru doldurunuz.");
    }
  }


  toggleSidebar(name): void {
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
  }
}
